// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating Device registration payload.
 * @see #/components/schemas/DeviceRegistrationRequest - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface DeviceRegistrationRequest {
    /**
     * MAC address of the device
     *
     */
    id: string;
    /**
     * The public key for the device
     *
     */
    public_key: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for DeviceRegistrationRequest
 */
export namespace DeviceRegistrationRequest {
    /**
     * DeviceRegistrationRequest Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * MAC address of the device
         * @type string (`dataFormat` is missing)
         */
        id: string;
        /**
         * The public key for the device
         * @type string (`dataFormat` is missing)
         */
        publicKey: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * DeviceRegistrationRequest DTO
     * Transforms DeviceRegistrationRequest model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend DeviceRegistrationRequest model */
        static toModel(obj: DeviceRegistrationRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend DeviceRegistrationRequest model */
        static toApi(obj: Model): DeviceRegistrationRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as DeviceRegistrationRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
